/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/grid-13";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Grid13";
export { I as Grid13 };
